/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Parts_1_TagInputs */

const en_mk_parts_1_tag = /** @type {(inputs: Mk_Parts_1_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`01 — Work`)
};

const id_mk_parts_1_tag = /** @type {(inputs: Mk_Parts_1_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`01 — Pekerjaan`)
};

/**
* | output |
* | --- |
* | "01 — Work" |
*
* @param {Mk_Parts_1_TagInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_parts_1_tag = /** @type {((inputs?: Mk_Parts_1_TagInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Parts_1_TagInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_parts_1_tag(inputs)
	return en_mk_parts_1_tag(inputs)
});